export default __webpack_public_path__ + "static/media/1752.c4cb8c2e.png";